<template>
    <div class="message-wrapper">
        <div class="msg-head" v-if="isMsgHead">
            <slot name="msg_head"></slot>
        </div>
        <div class="msg msg-body f-14" v-html="getTextMsgPreview" v-if="previewMode"></div>
        <div class="msg msg-body f-14" v-html="getTextMsg" v-else></div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
    name: "MessageWrapper",
    props: {
        textMessage: {
            type: String,
            default: "",
        },
        previewMode: {
            type: Boolean,
            default: false,
        },
        category: {
            type: String,
            default: "transaksi",
        },
    },
    data() {
        return {
            isLoadShortcode: false,
            listShortcode: [],
        };
    },
    mounted() {
        this.init();
    },
    computed: {
        getTextMsg() {
            return this.textMessage
                .replace(/\n/g, "<br />")
                .replace(/\n/g, "<br />")
                .replace(/\*([\w \@\#\%\&\*\(\)\"\'\:\[\]\-]*)\*/g, "<b>$1</b>")
                .replace(/\_([\w \@\#\%\&\*\(\)\"\'\:\[\]\-]*)\_/g, "<b>$1</b>")
                .replace(/\[([^\[\]\~]+)\]/g, "<span class='key-src'>$1</span>");
        },
        getTextMsgPreview() {
            if (this.previewMode) {
                let textmsg = this.textMessage;

                this.getShortkey.forEach((sk) => {
                    let sc = this.listShortcode.find((ls) => ls.code === `${sk}]`);
                    if (sc !== undefined) {
                        textmsg = textmsg.replace(`${sk}]`, sc.sample);
                    }
                });

                return textmsg
                    .replace(/\n/g, "<br />")
                    .replace(/\*([^\*\~]+)\*/g, "<b>$1</b>")
                    .replace(/\_([^\_\~]+)\_/g, "<i>$1</i>");
            } else {
                return this.getTextMsg;
            }
        },
        getShortkey() {
            let sk = this.textMessage.match(/(?=\[)(.*?)(?=\])/g);
            return sk;
        },
        isMsgHead() {
            return !!this.$slots.msg_head;
        },
    },
    methods: {
        ...mapActions({
            getShortcode: `metaModule/getShortcode`,
        }),
        init() {
            this.isLoadShortcode = true;

            this.getShortcode({ searchKey: "", category: this.category })
                .then((res) => {
                    let { code, data, status, msg } = res.data;
                    if (code === 200 && status) {
                        this.listShortcode = data;
                    }
                    this.isLoadShortcode = false;
                })
                .catch((e) => {
                    this.isLoadShortcode = false;
                    this.$toast.error(e);
                });
        },
    },
};
</script>

<style scoped>
.message-wrapper {
    background: #ede7de;
    margin: 0px -20px;
    margin-top: -4px;
    padding: 20px;
    max-height: 70vh;
    overflow-y: scroll;
    overflow-x: hidden;
}
.msg {
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.15);
    border-radius: 8px;
    padding: 8px 12px;
}
.msg-head {
    background: inherit;
    margin-bottom: 20px;
}
.msg-body {
    background: #e0ffc6;
}
</style>
